import { useTranslation } from "react-i18next";
import { Button, Modal } from "antd";
import { observer } from "mobx-react-lite";

import { userStore } from "../../stores/userStore";

interface Props {
  open: boolean;
  onClose: () => void;
}

export const TeamSizeAlertModal = observer(({ open, onClose }: Props) => {
  const { t } = useTranslation();
  const email = `sales@nextgis.${userStore.isRuRegion ? "ru" : "com"}`;

  return (
    <Modal
      open={open}
      title={null}
      width={380}
      onCancel={onClose}
      footer={
        <Button block size="large" type="primary" onClick={onClose}>
          {t("team.ok")}
        </Button>
      }
    >
      <p>
        {t("team.teamSizeAlertMsg")} <a href={`mailto:${email}`}>{email}</a>
      </p>
    </Modal>
  );
});
